import {SkeletonCircle} from '../../components/skeletons/SkeletonCircle';
import {Skeleton} from '../../components/skeletons/Skeleton';

interface ProfileHeaderProps {
  profileImageUrl: string;
  username?: string;
  isLoading: boolean;
  onImageError: (e: React.SyntheticEvent<HTMLImageElement>) => void;
}

/**
 * Profile header with image and username.
 */
export const ProfileHeader = ({
  profileImageUrl,
  username,
  isLoading,
  onImageError,
}: ProfileHeaderProps) => {
  if (isLoading) {
    return (
      <div className="flex flex-col items-center">
        <SkeletonCircle size="h-28 w-28" />
        <div className="mt-4 flex justify-center w-full">
          <Skeleton className="h-8 w-40" />
        </div>
      </div>
    );
  }

  return (
    <>
      <img
        src={profileImageUrl}
        id="profile-image"
        alt={username}
        onError={onImageError}
        className="rounded-full object-cover h-28 w-28 m-auto"
      />
      <div className="mt-1 flex items-center justify-center">
        <h2 className="mt-1 text-2xl/7 text-center">{username}</h2>
      </div>
    </>
  );
};
